import CompanyTheme from '@projectK/constants/CompanyTheme';
import PropTypes from 'prop-types';
import { WaiversTableMain } from '@projectK/MainComponents';
const WaiversLogTable = ({
  waiversLogData,
  verbiageSettings,
  loading,
  fetchData,
  titleSorting,
  descriptionSorting,
  productSorting,
  userSorting,
  dateSorting,
  setTitleSorting,
  setDescriptionSorting,
  setProductSorting,
  setUserSorting,
  setDateSorting,
  exportLoading,
}) => {
  const companyTheme = CompanyTheme();
  const parseContent = (content) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    return doc.body.textContent || '';
  };
  const updatedData = waiversLogData?.map((waiver) => ({
    ...waiver,
    waiver_description: waiver?.description,
    description: parseContent(waiver?.description),
  }));

  const handleSort = (column) => {
    setTitleSorting(column === 'waiver_name' ? !titleSorting : null);
    setDescriptionSorting(
      column === 'description' ? !descriptionSorting : null,
    );
    setProductSorting(column === 'product_name' ? !productSorting : null);
    setUserSorting(column === 'first_name' ? !userSorting : null);
    setDateSorting(column === 'created_at' ? !dateSorting : null);
  };
  const canHideSortIcon = (column) => {
    const columnToState = {
      waiver_name: titleSorting,
      description: descriptionSorting,
      product_name: productSorting,
      first_name: userSorting,
      created_at: dateSorting,
    };
    for (const columnName in columnToState) {
      if (columnName !== column && columnToState[columnName] !== null) {
        return true;
      }
    }
    return false;
  };
  return (
    <WaiversTableMain
      verbiageSettings={verbiageSettings}
      loading={loading}
      fetchData={fetchData}
      titleSorting={titleSorting}
      descriptionSorting={descriptionSorting}
      productSorting={productSorting}
      userSorting={userSorting}
      dateSorting={dateSorting}
      companyTheme={companyTheme}
      handleSort={handleSort}
      canHideSortIcon={canHideSortIcon}
      updatedData={updatedData}
      exportLoading={exportLoading}
    />
  );
};

export default WaiversLogTable;
WaiversLogTable.propTypes = {
  waiversLogData: PropTypes.array,
  verbiageSettings: PropTypes.object,
  loading: PropTypes.bool,
  fetchData: PropTypes.func,
  titleSorting: PropTypes.bool,
  descriptionSorting: PropTypes.bool,
  productSorting: PropTypes.bool,
  userSorting: PropTypes.bool,
  dateSorting: PropTypes.bool,
  setTitleSorting: PropTypes.func,
  setDescriptionSorting: PropTypes.func,
  setProductSorting: PropTypes.func,
  setUserSorting: PropTypes.func,
  setDateSorting: PropTypes.func,
  exportLoading: PropTypes.bool,
};
